














import { Component, Vue } from 'vue-property-decorator'

// components
import LinkTabs from '@/components/_uikit/LinkTabs.vue'

@Component({
  components: {
    LinkTabs,
  },
})
export default class Support extends Vue {
  private tabs = [
    {
      name: 'Частые вопросы',
      to: { name: 'master.support.faq' },
    },
    {
      name: 'Обращения',
      to: { name: 'master.support.tickets' },
    },
  ]

  private mounted() {
    if (this.$route.name === 'master.support') {
      this.$router.replace({ name: 'master.support.faq' })
    }
  }
}
